var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCodeDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 32.375V30.0625H30.0625V32.375H27.75Z",
    fill: "#9CA7AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 27.75V25.4375H23.125V27.75H20.8125Z",
    fill: "#9CA7AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 34.6875H25.4375V32.375H23.125V30.0625H20.8125V34.6875Z",
    fill: "#9CA7AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0625 30.0625V25.4375H32.375V30.0625H30.0625Z",
    fill: "#9CA7AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 30.0625H34.6875V34.6875H30.0625V32.375H32.375V30.0625ZM30.0625 23.125V20.8125H34.6875V25.4375H32.375V23.125H30.0625ZM27.75 23.125H25.4375V27.75H23.125V30.0625H27.75V23.125Z",
    fill: "#9CA7AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 23.125V20.8125H25.4375V23.125H20.8125Z",
    fill: "#9CA7AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 25.4375H11.5625V30.0625H6.9375V25.4375Z",
    fill: "#9CA7AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1875 34.6875H2.3125V20.8125H16.1875V34.6875ZM4.625 32.375H13.875V23.125H4.625V32.375ZM25.4375 6.9375H30.0625V11.5625H25.4375V6.9375Z",
    fill: "#9CA7AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 16.1875H20.8125V2.3125H34.6875V16.1875ZM23.125 13.875H32.375V4.625H23.125V13.875ZM6.9375 6.9375H11.5625V11.5625H6.9375V6.9375Z",
    fill: "#9CA7AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1875 16.1875H2.3125V2.3125H16.1875V16.1875ZM4.625 13.875H13.875V4.625H4.625V13.875Z",
    fill: "#9CA7AF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeDisabled);
export default __webpack_public_path__ + "static/media/qrCodeDisabled.f24f3a0dbbcba8e7a25d9ca01e1a169e.svg";
export { ForwardRef as ReactComponent };